import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { Size as InputSize } from '@jetbrains/ring-ui/components/input/input';
import Select from '@jetbrains/ring-ui/components/select/select';
import { useController } from 'react-hook-form';
import { Required } from '@common/form/important-asterisk';
import RingFieldsList from '@common/form/ring-fields-list';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import RegisteredInput from '@common/hook-form/registered-input';
import { AI_PRESET_OPTIONS, DEFAULT_PRESET_VALUES, DEFAULT_PROVIDER_VALUES } from '../../constants';
import { AzureAiProviderModels, OpenAiPlatformProviderModels } from './provider-models';
import styles from './open-ai-provider-form.css';
const API_KEY_EXISTENCE_INDICATOR = '⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱⸱';
export function OpenAiProviderForm({ form, availableProvider }) {
    var _a, _b, _c, _d;
    const { watch } = form;
    const apiKey = watch('provider.openai.apiKey');
    const preset = watch('provider.openai.preset');
    const azureRequiredModels = (_b = (_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _a === void 0 ? void 0 : _a.AZURE) === null || _b === void 0 ? void 0 : _b.filter(md => md.type === 'REQUIRED').map(md => md.model);
    const openaiRequiredModels = (_d = (_c = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _c === void 0 ? void 0 : _c.OPENAI) === null || _d === void 0 ? void 0 : _d.filter(md => md.type === 'REQUIRED').map(md => md.model);
    const providerController = useController({ name: 'provider.openai', control: form.control });
    const handlePresetSelect = useCallback((preset) => {
        if (!preset) {
            return;
        }
        switch (preset.key) {
            case 'AZURE': {
                providerController.field.onChange({
                    ...DEFAULT_PROVIDER_VALUES.openai,
                    ...DEFAULT_PRESET_VALUES.AZURE,
                    models: azureRequiredModels
                });
                break;
            }
            case 'OPENAI': {
                providerController.field.onChange({
                    ...DEFAULT_PROVIDER_VALUES.openai,
                    ...DEFAULT_PRESET_VALUES.OPENAI,
                    models: openaiRequiredModels
                });
                break;
            }
            default:
                assert_exhaustive(preset.key);
        }
    }, [azureRequiredModels, openaiRequiredModels, providerController.field]);
    return (_jsxs(RingFieldsList, { children: [_jsx(Select, { ...assignTestId('preset-select'), selectedLabel: "Preset", data: AI_PRESET_OPTIONS, selected: AI_PRESET_OPTIONS.find(item => item.key === preset), onSelect: handlePresetSelect }), _jsx(RegisteredInput, { name: "provider.openai.url", control: form.control, label: Required('Endpoint'), size: InputSize.L, controllerProps: { shouldUnregister: true }, ...assignTestId('api-endpoint-input') }, `url-${preset}`), _jsx(RegisteredInput, { name: "provider.openai.apiKey", control: form.control, label: Required('API key'), size: InputSize.L, placeholder: apiKey === null ? API_KEY_EXISTENCE_INDICATOR : '', type: "password", controllerProps: { shouldUnregister: true }, ...assignTestId('api-key-input') }, `apiKey-${preset}`), preset === 'AZURE' && (_jsx(AzureAiProviderModels, { className: styles.models, form: form, availableProvider: availableProvider })), preset === 'OPENAI' && (_jsx(OpenAiPlatformProviderModels, { className: styles.models, form: form, availableProvider: availableProvider }))] }));
}
